import { css } from '@emotion/react'
import {
  type ButtonProps,
  Button,
  SpacingToken,
} from '@livechat/design-system-react-components'
import { navigate } from 'gatsby'

export const btnCss = css`
  white-space: nowrap;
  margin-right: var(${SpacingToken.Spacing2});
`

interface Props extends ButtonProps {
  id: string
}

export const ViewCartButton = ({ className = '' }: Props) => {
  const handleClick = () => {
    navigate('/cart/')
  }

  return (
    <Button
      data-test="buy-btn"
      kind="text"
      onClick={handleClick}
      css={btnCss}
      fullWidth
      className={`${className} view-cart`}
    >
      Saved in cart
    </Button>
  )
}

export default ViewCartButton
